<template>
  <footer class="site-footer">
    <div class="site-footer__inner">
      <div class="site-footer__brand">
        <img src="../assets/img/logo.webp" alt="The Island House" />
        <p>Proper fish & chips, cooked fresh and served across the Midlands.</p>
        <div class="site-footer__socials">
          <a href="https://www.instagram.com/theislandhousetakeaway/?hl=en" target="_blank">Instagram</a>
          <a href="https://www.tiktok.com/@the.island.house?_t=8pzDAP0tHe5&_r=1" target="_blank">TikTok</a>
          <a href="https://www.facebook.com/theislandhouseuk" target="_blank">Facebook</a>
        </div>
      </div>
      <div>
        <h4>Quick links</h4>
        <router-link to="/">Home</router-link><router-link to="/our-food">Our Food</router-link><router-link to="/order">Order Online</router-link><router-link to="/locations">Locations</router-link><router-link to="/contact">Contact</router-link>
      </div>
      <div>
        <h4>Information</h4>
        <router-link to="/returns-policy">Returns & Legal</router-link>
        <router-link to="/contact">Contact us</router-link>
      </div>
      <div class="site-footer__cta">
        <h4>Hungry?</h4>
        <p>Choose your nearest Island House and get your order started.</p>
        <router-link to="/order" class="brand-button brand-button--compact">Order Online <span>→</span></router-link>
      </div>
    </div>
    <div class="site-footer__bottom">© {{ new Date().getFullYear() }} The Island House. All rights reserved.</div>
  </footer>
</template>

<style scoped>
.site-footer { background:#070707; border-top:1px solid #262626; padding:58px 24px 0; }
.site-footer__inner { max-width:1180px; margin:auto; display:grid; grid-template-columns:2fr 1fr 1fr 1.5fr; gap:45px; }
.site-footer__brand img { width:92px; margin-bottom:16px; }
.site-footer p { color:#b7b7b7; line-height:1.7; }
.site-footer h4 { color:var(--primary); text-transform:uppercase; letter-spacing:.1em; font-size:12px; margin-bottom:18px; }
.site-footer a:not(.brand-button) { color:#ddd; display:block; margin:10px 0; text-decoration:none; font-size:14px; }
.site-footer a:hover { color:var(--primary); }
.site-footer__socials { display:flex; gap:15px; flex-wrap:wrap; }
.site-footer__socials a { display:inline-block !important; }
.site-footer__bottom { max-width:1180px; margin:45px auto 0; border-top:1px solid #252525; color:#777; padding:20px 0; font-size:12px; }
@media(max-width:800px){ .site-footer__inner { grid-template-columns:1fr 1fr; } }
@media(max-width:520px){ .site-footer__inner { grid-template-columns:1fr; } }
</style>
